import type { enPos } from '../en/pos';

export const idPos: Record<keyof typeof enPos, string> = {
  'pos.nav.settings': 'Pengaturan',
  'pos.live.reconnecting': 'Menyambung ulang…',
  'pos.live.offlineShort': 'Offline',
  'pos.floor.openHours': 'Dibuka {hours} j {minutes} mnt',
  'pos.floor.openDays': 'Dibuka {days} hr',
  'pos.quick.title': 'Penjualan langsung',
  'pos.quick.subtitle': 'Ketuk menu, terima pembayaran, dan cetak struk — bawa pulang di kasir.',
  'pos.quick.hint': 'Tekan lama item untuk menandai habis atau tersedia.',
  'pos.quick.cart': 'Keranjang',
  'pos.quick.empty': 'Ketuk menu untuk menambahkan.',
  'pos.quick.inCart': '{count} di keranjang',
  'pos.quick.summary': '{count} item · {total}',
  'pos.quick.viewCart': 'Lihat keranjang',
  'pos.quick.estimate': 'Perkiraan. Pajak dan pembulatan ditambahkan di tagihan.',
  'pos.quick.pay': 'Bayar {amount}',
  'pos.quick.preparing': 'Menyiapkan tagihan…',
  'pos.quick.clear': 'Kosongkan',
  'pos.quick.newSale': 'Penjualan baru',
  'pos.quick.locked':
    'Pesanan sudah tersimpan. Coba lagi untuk melanjutkan, atau selesaikan dari Pesanan.',
  'pos.quick.retry': 'Lanjutkan pembayaran',
  'pos.quick.billTitle': 'Pembayaran',
  'pos.quick.availability': 'Ketersediaan',
  'pos.quick.add': 'Tambah',
  'pos.quick.addVariant': 'Tambah {name} lagi dengan pilihan sendiri',
  'pos.menu.category': 'Kategori',
  'pos.menu.allCategories': 'Semua kategori',
  'pos.orders.tabOpen': 'Terbuka ({count})',
  'pos.noAccess.title': 'Tidak ada akses kasir',
  'pos.noAccess.text':
    'Akun Anda tidak dapat menerima pembayaran di cabang mana pun. Minta peran kasir ke manajer.',
  'pos.settings.title': 'Pengaturan',
  'pos.settings.signedInAs': 'Masuk sebagai {name}',
  'pos.settings.server': 'Server: {url}',
  'pos.settings.version': 'Versi aplikasi {version}',
  'pos.tab.menu': 'Menu',
  'pos.tab.order': 'Pesanan ({count})',
  'pos.tab.bill': 'Tagihan',
  'pos.printer.title': 'Printer struk',
  'pos.printer.description':
    'Printer thermal Bluetooth. Pasangkan sekali di pengaturan Bluetooth Android, lalu pilih di sini.',
  'pos.printer.paired': 'Perangkat terpasang',
  'pos.printer.noneFound':
    'Belum ada perangkat terpasang. Pasangkan printer di pengaturan Bluetooth Android, lalu muat ulang.',
  'pos.printer.refresh': 'Muat ulang',
  'pos.printer.selected': 'Dipilih',
  'pos.printer.current': 'Printer: {name}',
  'pos.printer.none': 'Belum ada printer yang dipilih.',
  'pos.printer.paper': 'Lebar kertas',
  'pos.printer.paperOption': '{width} mm',
  'pos.printer.drawer': 'Buka laci kas setelah pembayaran tunai',
  'pos.printer.autoPrint': 'Cetak struk otomatis saat tagihan lunas',
  'pos.printer.test': 'Cetak halaman uji',
  'pos.printer.testTitle': 'Uji printer',
  'pos.printer.testDone': 'Halaman uji dikirim ke printer.',
  'pos.printer.forget': 'Hapus printer',
  'pos.printer.error.notConfigured': 'Pilih printer struk dulu di Pengaturan.',
  'pos.printer.error.unavailable': 'Perangkat ini tidak punya Bluetooth.',
  'pos.printer.error.off': 'Bluetooth mati. Nyalakan lalu coba lagi.',
  'pos.printer.error.permission': 'Izinkan "Perangkat di sekitar" agar apis bisa memakai printer.',
  'pos.printer.error.connect':
    'Tidak bisa tersambung ke printer. Pastikan printer menyala, terisi daya, dan berada di dekat.',
  'pos.printer.error.write': 'Pencetakan terputus. Coba lagi.',
  'pos.receipt.print': 'Cetak struk',
  'pos.receipt.printing': 'Mencetak…',
  'pos.receipt.printed': 'Struk dicetak.',
  'pos.order.newTakeaway': 'Bawa pulang',
  'pos.order.newDelivery': 'Pesan antar',
};
